module.exports = __webpack_public_path__ + "img/bannerBG.27e90861.png";